import { useEffect, useState } from 'react';
import ItemImage from '../../Assetes/Images/burgimg.jpg'
import Button from '@mui/material/Button';
import Collapse from 'react-bootstrap/Collapse';
import _ from 'lodash';
import { IMAGE_URL, priceunit } from '../../Components/client-config';
import { getCart, saveCart } from '../../Redux';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { resetCustomerDonation } from '../../Redux/actions/cart';
import useCurrentLocale from '../../hooks/useLanguage';
import { useTranslation } from 'react-i18next';
import React from 'react';

function CartItems(props: any) {
    const lang = useCurrentLocale();
    const cartData = useSelector((state: any) => state.cart.cartData);
    const history = useHistory();
    const dispatch = useDispatch();
    const { t } = useTranslation();

    function handleCollpase(currentIndex: any) {
        let dataCart = cartData;
        dataCart[currentIndex].collapseIn = !dataCart[currentIndex].collapseIn;
        props.saveCart(dataCart);
        props.setValue(props.value + 1);  //ForceFull Render component at price 0
    }
    function incrementQuantity(currentIndex: any) {
        let dataCart = cartData;
        if (dataCart[currentIndex].item) {
            let price = (dataCart[currentIndex].selectedsize.discount_price || dataCart[currentIndex].selectedsize.discount_price == 0) ? Math.round(dataCart[currentIndex].selectedsize.discount_price) : dataCart[currentIndex].selectedsize.mrp;
            dataCart[currentIndex].totalItemPrice = dataCart[currentIndex].totalItemPrice + price;
            dataCart[currentIndex].quantity += 1;
            props.saveCart(dataCart);
            props.setValue(props.value + 1);  //ForceFull Render component at price 0
        } else {
            let price = (dataCart[currentIndex].combo.discount_price || dataCart[currentIndex].combo.discount_price == 0) ? Math.round(dataCart[currentIndex].combo.discount_price) : dataCart[currentIndex].combo.combo_mrp_price;
            dataCart[currentIndex].totalItemPrice = dataCart[currentIndex].totalItemPrice + price;
            dataCart[currentIndex].quantity += 1;
            props.saveCart(dataCart);
            props.setValue(props.value + 1);  //ForceFull Render component at price 0
        }
    }

    function decrementQuantity(item: any, currentIndex: any) {
        let dataCart = cartData;
        let products: any = []
        let MapObj: any = {}
        if (item.item) {
            MapObj = {
                quantity: 1,
                price: item.price,
                item_id: item.item.menu_item_id,
                item_name: item.item.item_name,
            }
        }
        else if (item.combo) {
            MapObj = {
                quantity: 1,
                price: item.price,
                item_id: item.combo.combo_id,
                item_name: item.combo.combo_name
            }
        }
        products.push(MapObj)
        let windowObj = (window as any)
        windowObj.dataLayer.push({ ecommerce: null });
        windowObj.dataLayer.push({
            'event': 'remove_from_cart',
            'ecommerce': {
                'currency': 'PKR',
                'items': products
            }
        })
        if (dataCart[currentIndex].item) {
            let price = (dataCart[currentIndex].selectedsize.discount_price || dataCart[currentIndex].selectedsize.discount_price == 0) ? Math.round(dataCart[currentIndex].selectedsize.discount_price) : dataCart[currentIndex].selectedsize.mrp;
            if (dataCart[currentIndex].quantity == 1) {
                dataCart.splice(currentIndex, 1);
                props.saveCart(dataCart);
                props.setValue(props.value + 1);  //ForceFull Render component at price 0
                props.setHeaderUpdate(props.headerUpdate + 1)
                if (cartData.length <= 0) {
                    history.push(`/${lang}/menu`);
                    dispatch(resetCustomerDonation())
                }
            } else {
                dataCart[currentIndex].totalItemPrice = dataCart[currentIndex].totalItemPrice - price;
                dataCart[currentIndex].quantity -= 1;
                props.saveCart(dataCart);
                props.setValue(props.value + 1);  //ForceFull Render component at price 0
            }
        }
        else {
            let price = (dataCart[currentIndex].combo.discount_price || dataCart[currentIndex].combo.discount_price == 0) ? Math.round(dataCart[currentIndex].combo.discount_price) : dataCart[currentIndex].combo.combo_mrp_price;
            if (dataCart[currentIndex].quantity == 1) {
                dataCart.splice(currentIndex, 1);
                props.saveCart(dataCart);
                props.setValue(props.value + 1);  //ForceFull Render component at price 0
                props.setHeaderUpdate(props.headerUpdate + 1)
                if (cartData.length <= 0) {
                    history.push(`/${lang}/menu`);
                }
            } else {
                dataCart[currentIndex].totalItemPrice = dataCart[currentIndex].totalItemPrice - price;
                dataCart[currentIndex].quantity -= 1;
                props.saveCart(dataCart);
                props.setValue(props.value + 1);  //ForceFull Render component at price 0
            }
        }
    }
    function checkAddOneSelected(modifiers: any) {
        let success = false;
        Object.keys(modifiers).map(
            (key: any, index) => {
                modifiers[key].map(
                    (item: any, index: any) => {
                        if (item.selected === true) {
                            success = true
                            return;
                        }
                    })
            })
        return success;
    }
    return (
        <div className='cart-items'>
            <div className='items-container'>
                {props?.carts?.combo ?
                    <img src={`${IMAGE_URL}${props?.carts?.combo?.image_url}`} className='item-container' alt={props.carts.combo.alt_text ? props.carts.combo.alt_text : props.carts.combo.combo_name} /> :
                    <img src={`${IMAGE_URL}${props?.carts?.selectedsize?.image_url}`} className='item-container' alt={props.carts.selectedsize.alt_text ? props?.carts?.selectedsize?.alt_text : props?.carts?.item?.item_name} />
                }
                <div className='w-100'>
                    <div className="item-image">
                        <div>
                            <h5 className='item-text'>{(!_.isEmpty(props.carts.item) &&
                                props.carts.item.item_name) ||
                                (!_.isEmpty(props.carts.combo) &&
                                    props.carts.combo.combo_name)}{" "} 
                                    {/* <span style={{fontSize:"18px"}}>({props.carts.price} {" * "} {props.carts.quantity})</span> */}
                            </h5>
                            {props.carts.selectedsize?.size && <p className='add-varient'>({props.carts.selectedsize.size})</p>}
                        </div>
                        <h5 className='item-text'>
                            {priceunit + props.carts.totalItemPrice}
                          
                        </h5>
                    </div>
                    <div className='item-image mt-2'>
                        <div className='d-flex align-item-center gap-10'>
                            <Button className='add-btn p-0 color-white' onClick={() => decrementQuantity(props.carts, props.index)} color="error">
                                {props.carts.quantity > 1 ? <i className="ri-subtract-line"></i> : <i className="ri-delete-bin-line"></i>}</Button>
                            <span className='cont-item'> {props.carts.quantity}</span>
                            <Button className='add-btn p-0 color-white' onClick={() => incrementQuantity(props.index)} color="error"><i className="ri-add-line"></i></Button>
                        </div>
                        {(!_.isEmpty(props.carts.modifiers)) && checkAddOneSelected(props.carts.modifiers) &&
                            <div>
                                <Button
                                    className='detail-btn font-medium'
                                    onClick={() => handleCollpase(props.index)}
                                    variant="contained" color="error"
                                    aria-expanded={props.carts.collapseIn}
                                > {t("DETAIL")}<i className={props.carts.collapseIn ? 'ri-arrow-up-s-line' : "ri-arrow-down-s-line"}></i></Button>
                            </div>
                        }
                    </div>
                </div>
            </div>
            <Collapse in={props.carts.collapseIn}>
                <div className='item-quantity bucket-detail-ar' id="example-collapse-text">
                    {
                        (!_.isEmpty(props.carts.modifiers)) &&
                        <>
                            {Object.keys(props.carts.modifiers).map(
                                (key: any, index) => {
                                    return (
                                        props.carts.modifiers[key].map(
                                            (item: any, index: any) => {
                                                return (
                                                    item.selected === true &&
                                                    <div key={index} className="d-flex justify-content-between px-2">
                                                        <li style={{ paddingLeft: '1rem', fontSize: 13 }}>{item.modifier_name + (item.for_combo != 1 ? ' x ' + item.quantity : "")}</li>
                                                        <p style={{ paddingLeft: '1rem', fontSize: 13 }}>
                                                            {((item.discount_price || item.discount_price == 0)) ?
                                                                <>
                                                                    {priceunit + Math.round(item.discount_price) * item.quantity}
                                                                </>
                                                                :
                                                                <>
                                                                    {item.modifier_sale_price > 0 && (priceunit + item.modifier_sale_price * item.quantity)}
                                                                </>
                                                            }
                                                        </p>
                                                    </div>
                                                )
                                            })
                                    )
                                }
                            )
                            }
                        </>
                    }
                </div>
            </Collapse>
        </div>
    )
}
const mapDispatchToProps = (dispatch: any) => {
    return {
        getCart: function (cart: any) {
            dispatch(getCart(cart));
        },
        saveCart: function (cart: any) {
            dispatch(saveCart(cart));
        },
    };
};

export default connect(null, mapDispatchToProps)(CartItems);
